module.exports = __webpack_public_path__ + "img/easyredeem.65d50b06.png";